import Vue from 'vue';
import Router from 'vue-router';
import routes from './routers';
import store from '../store/index'

import { CONSTS } from '../untils/consts'

Vue.use(Router)

//解决重复点击路由报错问题
// const originalPush = Router.prototype.push;
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// };

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const isLogin = store.getters.isLogin;
    
    if (isLogin) {
      next();
    } else {
      next({
        path: CONSTS.contextPath + '/login.html',
        query: { redirect: to.fullPath }
      });
    }
  } else {
    next();
  };
})

router.afterEach(to => {
  if (to.meta && to.meta.title) {//判断是否有标题
    document.title = to.meta.title;
  }
});

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js